'use client';

import { clientLogBy, CriteoTracker } from '@weberus/client-tracker';
import { useEffect } from 'react';

interface ClientLoggerProps<T extends Record<string, unknown> | null> {
  pageName: string;
  logMeta?: T;
}

/**
 * 클라이언트 환경에서 clientLogBy를 호출하는 'client component' 컴포넌트
 */
export const ClientViewLogger = <T extends Record<string, unknown> | null>({
  pageName,
  logMeta,
}: ClientLoggerProps<T>) => {
  useEffect(() => {
    clientLogBy('view', pageName, logMeta);

    if (pageName === 'Home') {
      CriteoTracker.push([{ event: 'viewHome' }]);
    }
  }, []);

  // UI를 렌더링하지 않음
  return null;
};
